import { MONTAGE_COMPONENT_MAP } from './../../constants'
import { parseJSONString } from './../../utils'
import { Message } from 'element-ui'

// 新增 编辑均使用
// 组件转换表
const MONTAGE_TRANSFORM_MAP = {
    Cascader(montageField) {
        const configSetting = parseJSONString(montageField.configSetting, {})
        const multiple = Boolean(configSetting.multiple)
        const supportLatLng = Boolean(configSetting.supportLatLng)

        if (supportLatLng) {
            return {
                field: montageField.fieldLetter,
                data: '',
                type: MONTAGE_COMPONENT_MAP.GeoMapLocation,
                slot: '',
                isHidden: false,
                isKeepOriginData: false,
                attribute: {
                    field: montageField.fieldLetter,
                    compSlot: '',
                    type: '',
                    value: '',
                    readonly: !montageField.isEdit,
                    icon: '',
                    number: '',
                    class: '',
                    label: montageField.fieldName,
                    ...configSetting,
                },
            }
        } else {
            return {
                field: montageField.fieldLetter,
                data: [],
                type: MONTAGE_COMPONENT_MAP[montageField.formType],
                slot: '',
                isHidden: false,
                isKeepOriginData: false,
                attribute: {
                    field: montageField.fieldLetter,
                    compSlot: '',
                    type: '',
                    value: '',
                    maxlength: '',
                    minlength: '',
                    clearable: true,
                    readonly: !montageField.isEdit,
                    icon: '',
                    rows: '',
                    autosize: false,
                    number: '',
                    class: '',
                    label: montageField.fieldName,
                    ...configSetting,
                    fieldInitOptions: [],
                    selectProps: {
                        clearable: true,
                        placeholder: configSetting.placeholder,
                    },
                    initProps: { lazy: true, checkStrictly: true, multiple },
                    formatOptions: (result) => {
                        let { success = [], node = {} } = result || {}
                        node = success.map((item) => ({
                            value: item.id,
                            label: item.name,
                            leaf: node.level >= configSetting.level || item.end,
                        }))
                        return node
                    },
                    filterable: Boolean(configSetting.filterable),
                    isCustomCheck: !multiple,
                    style: {
                        width: '100% !important',
                    },
                },
            }
        }
    },
    Select(montageField, businessParams) {
        const configSetting = parseJSONString(montageField.configSetting, {})
        const remote = Boolean(configSetting.remote)
        let options = []
        if (!remote && configSetting.options) {
            options = configSetting.options.split(',').map((option) => {
                let value = option.split('|')[0]
                let label = option.split('|')[1]
                if (/^[0-9]/.test(value)) {
                    value = Number(value)
                }
                return { value, label }
            })
        }
        return {
            field: montageField.fieldLetter,
            data: '',
            type: MONTAGE_COMPONENT_MAP[montageField.formType],
            slot: '',
            isHidden: false,
            isKeepOriginData: false,
            attribute: {
                field: montageField.fieldLetter,
                compSlot: '',
                type: '',
                value: '',
                maxlength: '',
                minlength: '',
                clearable: true,
                readonly: !montageField.isEdit,
                icon: '',
                rows: '',
                autosize: false,
                number: '',
                class: '',
                label: montageField.fieldName,
                ...configSetting,
                options,
                needRemoteOnce: remote,
                formatOptions: (result) => {
                    let { success = [] } = result || {}
                    return success
                },
                remote,
                selectProps: { remote },
                filterable: Boolean(configSetting.filterable),
                extApiParams: businessParams,
            },
        }
    },
    Upload(montageField) {
        const configSetting = parseJSONString(montageField.configSetting, {})
        // 多种组件类型，需判断
        let type
        if (configSetting.isGraphic) {
            type = 'Graphic'
        } else {
            type = 'Upload'
        }
        return {
            field: montageField.fieldLetter,
            data: [],
            type: MONTAGE_COMPONENT_MAP[type],
            slot: '',
            isHidden: false,
            isKeepOriginData: false,
            attribute: (data) => {
                const picList =
                    data && data[montageField.fieldLetter]
                        ? data[montageField.fieldLetter]
                        : []
                return {
                    field: montageField.fieldLetter,
                    compSlot: '',
                    type: '',
                    maxlength: '',
                    minlength: '',
                    clearable: true,
                    readonly: !montageField.isEdit,
                    icon: '',
                    rows: '',
                    autosize: false,
                    number: '',
                    class: 'no-wrap',
                    label: montageField.fieldName,
                    ...configSetting,
                    prefix: {
                        imgServer: '//img30.360buyimg.com/vip/',
                    },
                    imageProps: {
                        'preview-src-list': picList,
                    },
                    urls: picList,
                    withCredentials: true,
                    limit: configSetting.uploadLimit[1],
                    accept: configSetting.type,
                    'before-upload': (file) => {
                        // 补充文件大小校验逻辑
                        let fileLimit = configSetting.size
                        const isLt1M = file.size / 1024 / 1024 < fileLimit
                        if (!isLt1M) {
                            Message({
                                message: `上传文件大小不能超过${fileLimit}M!`,
                                type: 'warning',
                            })
                            return false
                        }
                        const { name } = file
                        const validFileNameReg =
                            /^[\u4e00-\u9fa5A-Za-z_\-.0-9]+$/g
                        if (validFileNameReg.test(name)) {
                            return true
                        } else {
                            Message.error(
                                '文件名称的有效字符为中文、英文、下划线、中划线、点，其它为非法字符。请检查文件名称是否有效！'
                            )
                            return false
                        }
                    },
                }
            },
        }
    },
    Radio(montageField) {
        // TODO remote retail-radio不支持remote
        const configSetting = parseJSONString(montageField.configSetting, {})
        let options = []
        if (configSetting.options) {
            options = configSetting.options.split(',').map((option) => {
                let value = option.split('|')[0]
                let label = option.split('|')[1]
                if (/^[0-9]/.test(value)) {
                    value = Number(value)
                }
                return { value, label }
            })
        }
        return {
            field: montageField.fieldLetter,
            data: options[0].value,
            type: MONTAGE_COMPONENT_MAP[montageField.formType],
            slot: '',
            isHidden: false,
            isKeepOriginData: false,
            attribute: {
                field: montageField.fieldLetter,
                compSlot: '',
                type: '',
                value: '',
                maxlength: '',
                minlength: '',
                clearable: true,
                readonly: !montageField.isEdit,
                icon: '',
                rows: '',
                autosize: false,
                number: '',
                class: '',
                label: montageField.fieldName,
                ...configSetting,
                fieldInitOptions: options,
            },
        }
    },
    Checkbox(montageField) {
        // TODO remote retail-radio不支持remote
        const configSetting = parseJSONString(montageField.configSetting, {})
        let options = []
        if (configSetting.options) {
            options = configSetting.options.split(',').map((option) => {
                let value = option.split('|')[0]
                let label = option.split('|')[1]
                if (/^[0-9]/.test(value)) {
                    value = Number(value)
                }
                return { value, label }
            })
        }
        return {
            field: montageField.fieldLetter,
            data: [],
            type: MONTAGE_COMPONENT_MAP[montageField.formType],
            slot: '',
            isHidden: false,
            isKeepOriginData: false,
            attribute: {
                field: montageField.fieldLetter,
                compSlot: '',
                type: '',
                value: '',
                maxlength: '',
                minlength: '',
                clearable: true,
                readonly: !montageField.isEdit,
                icon: '',
                rows: '',
                autosize: false,
                number: '',
                class: '',
                label: montageField.fieldName,
                ...configSetting,
                fieldInitOptions: options,
            },
        }
    },
    Input(montageField, businessParams) {
        const configSetting = parseJSONString(montageField.configSetting, {})
        return {
            field: montageField.fieldLetter,
            data: '',
            type: MONTAGE_COMPONENT_MAP[montageField.formType],
            slot: '',
            isHidden: false,
            isKeepOriginData: false,
            attribute: {
                field: montageField.fieldLetter,
                compSlot: '',
                type: '',
                value: '',
                maxlength: Number(configSetting.max),
                minlength: Number(configSetting.minLength),
                clearable: true,
                readonly: !montageField.isEdit,
                icon: '',
                rows: '',
                autosize: false,
                number: '',
                class: '',
                label: montageField.fieldName,
                ...configSetting,
                needSuggestions:
                    Boolean(configSetting.remote) &&
                    Boolean(configSetting.remoteApiPath),
                extApiParams: businessParams,
                // 远程校验，只需提示，不需要建议
                // sussess string
                // error Object
                formatOptions: () => {
                    return []
                },
                triggerOnFocus: false,
                'popper-append-to-body': false,
            },
        }
    },
    DatePicker(montageField) {
        const configSetting = parseJSONString(montageField.configSetting, {})
        let type
        if (configSetting.type === 'timerange') {
            type = MONTAGE_COMPONENT_MAP.TimePicker
        } else {
            type = MONTAGE_COMPONENT_MAP.DatePicker
        }
        return {
            field: montageField.fieldLetter,
            data: '',
            type,
            slot: '',
            isHidden: false,
            isKeepOriginData: false,
            attribute: {
                field: montageField.fieldLetter,
                compSlot: '',
                type: '',
                value: '',
                maxlength: '',
                minlength: '',
                clearable: true,
                readonly: !montageField.isEdit,
                icon: '',
                rows: '',
                autosize: false,
                number: '',
                class: '',
                label: montageField.fieldName,
                ...configSetting,
                'is-range': true,
            },
        }
    },
    RelationField(montageField) {
        const configSetting = parseJSONString(montageField.configSetting, {})
        return {
            field: montageField.fieldLetter,
            data: '',
            type: MONTAGE_COMPONENT_MAP[montageField.formType],
            slot: '',
            isHidden: false,
            isKeepOriginData: false,
            attribute: {
                field: montageField.fieldLetter,
                compSlot: '',
                type: '',
                value: '',
                maxlength: '',
                minlength: '',
                clearable: true,
                readonly: !montageField.isEdit,
                icon: '',
                rows: '',
                autosize: false,
                number: '',
                class: '',
                label: montageField.fieldName,
                rule: [montageField.rule],
                ...configSetting,
            },
        }
    },
}

/**
 * @description default transform montage field object to schema field object method
 * @param {Object} montageField montage field object
 * @returns {Object} schema field object
 */
const defaultTransform = (montageField) => {
    const configSetting = parseJSONString(montageField.configSetting, {})
    // 纯文本
    if (!montageField.isEdit) {
        return {
            field: montageField.fieldLetter,
            data: (data) => {
                if (!data) {
                    return ''
                }
                return data[montageField.fieldLetter]
            },
            type: '',
            slot: montageField.fieldLetter,
            isHidden: false,
            isKeepOriginData: false,
            attribute: {
                field: montageField.fieldLetter,
                compSlot: '',
                type: '',
                value: '',
                maxlength: '',
                minlength: '',
                clearable: true,
                readonly: !montageField.isEdit,
                icon: '',
                rows: '',
                autosize: false,
                number: '',
                class: '',
                label: montageField.fieldName,
                ...configSetting,
            },
        }
    } else {
        return {
            field: montageField.fieldLetter,
            data: '',
            type: MONTAGE_COMPONENT_MAP[montageField.formType],
            slot: '',
            isHidden: false,
            isKeepOriginData: false,
            attribute: {
                field: montageField.fieldLetter,
                compSlot: '',
                type: '',
                value: '',
                maxlength: '',
                minlength: '',
                clearable: true,
                readonly: !montageField.isEdit,
                icon: '',
                rows: '',
                autosize: false,
                number: '',
                class: '',
                label: montageField.fieldName,
                ...configSetting,
            },
        }
    }
}

/**
 * transform montage to schema
 * @param {Array} montage montage field list
 * @returns {Array} retail form schema
 */
const montageToSchema = (montage, businessParams) => {
    if (!Array.isArray(montage)) {
        return []
    }
    return montage.map((item) =>
        MONTAGE_TRANSFORM_MAP[item.formType]
            ? MONTAGE_TRANSFORM_MAP[item.formType](item, businessParams)
            : defaultTransform(item, businessParams)
    )
}

export default montageToSchema
